<template>
  <div class="mt-2" role="list">
    <div
      role="listitem"
      class="file_wrapper"
      v-for="certificate in uploadedCertificatesUrl"
      :key="certificate.name"
    >
      <p class="file_name">{{ certificate.name }}</p>
      <div class="py-2 pr-1 file_actions">
        <button
          aria-label="Download other certificate"
          @click="downloadCertificate(certificate.url)"
          class="btn btn-ghost-primary includedIcon noText"
        >
          <download-icon alt="" />
        </button>
        <button
          class="btn btn-ghost-danger includedIcon noText"
          aria-label="delete other certificate"
          @click="deleteCertificate(certificate.name)"
        >
          <trash-icon alt="" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import store from '@/store/store';
import { DownloadIcon, TrashIcon } from 'vue-feather-icons';

export default {
  components: {
    DownloadIcon,
    TrashIcon,
  },
  computed: {
    uploadedCertificatesUrl() {
      return store.getters['authStudent/preworkWorkplaceSafetyOther'];
    },
  },
  methods: {
    async deleteCertificate(name) {
      store.dispatch('authStudent/removeWorkplaceSafetyCertificateOther', name);
    },
    downloadCertificate(url) {
      window.open(url, '_blank');
    },
  },
};
</script>

<style scoped>
.file_wrapper {
  overflow: hidden;
  display: flex;
  justify-content: space-between;
  align-content: center;
}
.file_name {
  padding: 5px 0;
}

.file_actions {
  display: flex;
}

.file_actions button {
  float: left !important;
  margin: 0 5px;
  width: 30px !important;
  height: 30px !important;
}
</style>
